/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-03-17 10:33:30
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\extendsFields\index.ts
 */
import { Fields_imgcode as imgcode } from "./imgcode";
import { Fields_captcha_group as captchaGroup } from "./captchaGroup";
import { Fields_smscode as smscode } from "./smscode";
export const valueTypeMap = {
    /** 图片验证码 */
    imgcode,
    /** 手机验证码组合 */
    captchaGroup,
    /** 短信验证码 */
    smscode
}